// extracted by mini-css-extract-plugin
export default {"main":"style-module__main___hyVkZ","root":"style-module__root___hBmL9"};
    if(module.hot) {
      // 1729151128715
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  